// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2Qs5f","content":"styles_content__COXtO","selectAll":"styles_selectAll__3uLiv"};